type RuntimeEnv = "dev" | "prod";

export const getRuntimeEnv = (): RuntimeEnv => {
  const { hostname } = window.location;

  // Local development
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return import.meta.env.VITE_PROFILE === "prod" ? "prod" : "dev";
  }

  // Explicit domains
  if (hostname === "admin.dev.syncrosale.com") return "dev";
  if (hostname === "admin.syncrosale.com") return "prod";

  // Fallbacks (preview / custom subdomains)
  if (hostname.includes("dev")) return "dev";

  return "prod";
};
